'use client';

import NewsletterForm from '@/components/ui/Content/NewsletterForm';

export function StayUpdated() {
  return (
    <section className='bg-background px-6 py-16 md:px-8'>
      <div className='mx-auto max-w-4xl'>
        <div
          className='hover:shadow-primary/5 relative overflow-hidden rounded-[2.5rem] p-10 shadow-2xl transition-all duration-500 md:p-16'
          style={{
            backgroundColor: '#066653',
            backgroundImage:
              "url('data:image/svg+xml,%3Csvg width=\\'60\\' height=\\'60\\' viewBox=\\'0 0 60 60\\' xmlns=\\'http://www.w3.org/2000/svg\\'%3E%3Cg fill=\\'none\\' fill-rule=\\'evenodd\\'%3E%3Cg fill=\\'%23ffffff\\' fill-opacity=\\'0.03\\'%3E%3Cpath d=\\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
          }}>
          {/* Decorative Glow */}
          <div className='pointer-events-none absolute -right-12 -bottom-12 size-64 rounded-full bg-white/10 blur-[100px]' />
          <div className='bg-primary/20 pointer-events-none absolute -top-12 -left-12 size-48 rounded-full blur-[80px]' />

          <div className='relative z-10 flex flex-col items-center justify-between gap-12 text-center md:flex-row md:text-left'>
            <div className='max-w-md space-y-4'>
              <h2 className='font-serif text-4xl font-black tracking-tight text-white md:text-5xl'>
                Stay Updated
              </h2>
              <p className='mx-auto max-w-sm text-lg leading-relaxed font-medium text-white/80 md:mx-0'>
                Get the latest biotech insights and data stories delivered
                directly to your inbox.
              </p>
            </div>

            <div className='w-full max-w-md transform transition-transform duration-500 hover:scale-[1.02] md:shrink-0'>
              <NewsletterForm />
              <p className='mt-4 text-center text-[10px] font-black tracking-widest text-white/40 uppercase md:text-right'>
                Join 5k+ Bioinfometrics readers
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
